import React from 'react';
import '../../css/components/footer.css';
import { Link, Location } from 'react-router';
import { withRouter } from '../../hooks/withRouter';

interface FooterProps {
  location: Location;
}

interface FooterNavLink {
  label: string;
  to: string;
  newTab?: boolean;
}

interface SocialLink {
  label: string;
  href: string;
  icon: string;
}

const LINKS: FooterNavLink[] = [
  { label: 'About', to: '/about' },
  { label: 'Contact Us', to: '/contact' },
  { label: 'FAQ', to: '/faq' },
  { label: 'Blog', to: '/blogs' },
  { label: 'Terms Of Use', to: '/terms-of-use', newTab: true },
  { label: 'Privacy Policy', to: '/privacy-policy', newTab: true },
];

const SOCIAL: SocialLink[] = [
  { label: 'Facebook', href: 'https://www.facebook.com/CargoWise/', icon: 'fa-facebook-f' },
  { label: 'X', href: 'https://twitter.com/cargowise', icon: 'fa-x-twitter' },
  { label: 'YouTube', href: 'https://www.youtube.com/@_CargoWise', icon: 'fa-youtube' },
  { label: 'LinkedIn', href: 'https://www.linkedin.com/company/cargowiseone', icon: 'fa-linkedin-in' },
];

const Footer: React.FC<FooterProps> = ({ location }) => {
  const year = new Date().getFullYear();

  return (
    <footer className="ss-footer">
      <div className="ss-footer__bar">
        <img
          className="ss-footer__logo"
          src="/app-images/logo/CW_Landside-logo.svg"
          alt="SecurSpace"
        />

        <nav className="ss-footer__nav" aria-label="Footer">
          {LINKS.map((l) => {
            const active = location.pathname === l.to;
            return (
              <Link
                key={l.label}
                to={l.to}
                className={active ? 'is-active' : undefined}
                aria-current={active ? 'page' : undefined}
                {...(l.newTab ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
              >
                {l.label}
              </Link>
            );
          })}
        </nav>

        <ul className="ss-footer__social">
          {SOCIAL.map((s) => (
            <li key={s.label}>
              <a
                href={s.href}
                aria-label={s.label}
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className={`fa-brands ${s.icon}`} aria-hidden="true" />
              </a>
            </li>
          ))}
        </ul>
      </div>

      <div className="ss-footer__legal">
        <span>&copy; SecurSpace {year} &mdash; All rights reserved</span>
      </div>
    </footer>
  );
};

export default withRouter(Footer);
